import {Transaction} from "algosdk";

import {encodeUnsignedTransactionInBase64} from "../../util/transaction/transactionUtils";
import {WalletConnectTransaction, WalletTransaction} from "./WalletConnect.models";
import {
  WALLET_CONNECT_MODAL_CARD_STYLES,
  WALLET_CONNECT_MODAL_OVERLAY_STYLES,
  WALLET_CONNECT_MODAL_STYLES
} from "./WalletConnect.constants";

function composeTransaction(
  transaction: WalletConnectTransaction,
  signerAddress?: string
) {
  let signers: WalletTransaction["signers"];

  if (signerAddress && !(transaction.signers || []).includes(signerAddress)) {
    signers = [];
  }

  const walletTransaction: WalletTransaction = {
    txn: encodeUnsignedTransactionInBase64(transaction.txn as unknown as Transaction)
  };

  if (Array.isArray(signers)) {
    walletTransaction.signers = signers;
  }

  if (transaction.authAddr) {
    walletTransaction.authAddr = transaction.authAddr;
  }

  if (transaction.message) {
    walletTransaction.message = transaction.message;
  }

  if (transaction.msig) {
    walletTransaction.msig = transaction.msig;
  }

  return walletTransaction;
}

function getSignTxnRequestParams(
  txns: WalletConnectTransaction[] | WalletConnectTransaction[][],
  signerAddress?: string
) {
  let newTxns = txns;

  if (!Array.isArray(txns[0])) {
    newTxns = [txns as WalletConnectTransaction[]];
  }

  return (newTxns as WalletConnectTransaction[][]).flatMap((txGroup) =>
    txGroup.map<WalletTransaction>((txGroupDetail) =>
      composeTransaction(txGroupDetail, signerAddress)
    )
  );
}

/**
 * This function is used to setup a MutationObserver to observe the WalletConnect modal.
 * The WalletConnect modal is a shadow DOM element, so we need to use MutationObserver to observe
 * the modal's shadow DOM to detect if the modal is opened.
 */
function setupWalletConnectObserver() {
  const walletConnectObserver = new MutationObserver(() => {
    const modalRoot = document.getElementsByTagName("w3m-modal")[0];

    if (!modalRoot) {
      return;
    }

    const walletConnectModalOverlay = modalRoot.shadowRoot?.querySelector(
      ".w3m-overlay"
    ) as HTMLDivElement | undefined;

    if (walletConnectModalOverlay) {
      Object.assign(walletConnectModalOverlay.style, WALLET_CONNECT_MODAL_OVERLAY_STYLES);

      const walletConnectModal = walletConnectModalOverlay.querySelector(
        ".w3m-container"
      ) as HTMLDivElement | undefined;

      if (walletConnectModal) {
        Object.assign(walletConnectModal.style, WALLET_CONNECT_MODAL_STYLES);

        const walletConnectModalCard =
          (walletConnectModal.querySelector(".w3m-card") as HTMLDivElement) || undefined;

        if (walletConnectModalCard) {
          Object.assign(walletConnectModalCard.style, WALLET_CONNECT_MODAL_CARD_STYLES);
        }
      }
    }
  });

  walletConnectObserver.disconnect();

  walletConnectObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

export {setupWalletConnectObserver, getSignTxnRequestParams};
